import React from "react";
import DialogList from "../SecComponents/dialogList";

const availableReferences = {
  message: "Por favor, indique alguna de las referencias:",
  optionList: ["No. Solicitud", "Doc. Transporte"],
};

function Transporte(props) {
  return (
    <div className="row" style={{ width: "100%" }}>
      <DialogList references={availableReferences} />
    </div>
  );
}

export default Transporte;
